/* eslint-disable import/prefer-default-export */
import HeaderFooterWrapper from './src/HeaderFooterWrapper';

// To wrap this outside the default pageWrapper of the application we need to
// wrap it higher up in the hierarchy, in the rootWrapper.
export const wrapRootElement = HeaderFooterWrapper;
